/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfListOfIChingConsultationMarkerDto } from '../../models/platform-api-result-of-list-of-i-ching-consultation-marker-dto';

export interface GetIchingConsultationsMineForChartChartid$Params {

/**
 * De chart waarvan de raadplegingen een moment zijn.
 */
  chartId: string;

/**
 * Ook raadplegingen zonder gekoppelde chart meegeven (eigen chart).
 */
  includeUnlinked?: boolean;
}

export function getIchingConsultationsMineForChartChartid(http: HttpClient, rootUrl: string, params: GetIchingConsultationsMineForChartChartid$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfListOfIChingConsultationMarkerDto>> {
  const rb = new RequestBuilder(rootUrl, getIchingConsultationsMineForChartChartid.PATH, 'get');
  if (params) {
    rb.path('chartId', params.chartId, {});
    rb.query('includeUnlinked', params.includeUnlinked, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfListOfIChingConsultationMarkerDto>;
    })
  );
}

getIchingConsultationsMineForChartChartid.PATH = '/api/iching/consultations/mine/for-chart/{chartId}';
